import { TextV2 } from '@withjoy/joykit';
import React from 'react';

import {
  AdminMenuButtonV2,
  AdminMenuDropdown,
  AdminMenuInfo,
  AdminMenuNav,
  AdminMenuNavButton,
  AdminMenuNavList,
  AdminMenuNavListDivider,
  AdminMenuNavListItem,
  AdminMenuRoot,
  ButtonAvatar,
  HamburgerMenuIcon,
  InfoPhoto,
  InfoPhotoOverlay,
  InfoPhotoOverlayIcon,
  InfoPhotoWrapper
} from './AdminMenu.styles';
import { useAdminMenuController } from '@apps/admin/routes/Dashboard/components/AdminMenu/AdminMenu.controller';
import { wrapWithAdminMenuHealthProvider } from '@apps/admin/routes/Dashboard/components/AdminMenu/AdminMenu.health';
import { GetEventForAdminMenuQuery } from '@graphql/generated';
import { ApolloError } from '@apollo/client';
export interface AdminMenuProps {
  eventHandle: string;
  adminData?: GetEventForAdminMenuQuery | undefined;
  loading?: boolean;
  error?: ApolloError | undefined;
}

export const AdminMenu: React.FC<AdminMenuProps> = wrapWithAdminMenuHealthProvider(({ eventHandle, adminData, loading, error }) => {
  const { menuRef, isOpen, onToggle, photoUrl, photoAltTag, eventDisplayName, menuOptions, photosPath, telemetry } = useAdminMenuController({
    eventHandle,
    adminData,
    error
  });

  if (loading) {
    return null;
  }

  return (
    <AdminMenuRoot ref={menuRef}>
      <AdminMenuButtonV2 onClick={onToggle}>
        <HamburgerMenuIcon isOpen={isOpen}>
          {[...Array(4)].map((_, i) => (
            <span key={i} />
          ))}
        </HamburgerMenuIcon>
        <ButtonAvatar src={photoUrl} alt={photoAltTag} />
      </AdminMenuButtonV2>
      <AdminMenuDropdown isOpen={isOpen}>
        <AdminMenuInfo>
          <InfoPhotoWrapper href={photosPath} onClick={() => telemetry.openPage({ label: 'photos', section: 'Avatar' })}>
            <InfoPhoto src={photoUrl} alt={photoAltTag} />
            <InfoPhotoOverlay>
              <InfoPhotoOverlayIcon />
              <TextV2 typographyVariant="body1">Edit Photos</TextV2>
            </InfoPhotoOverlay>
          </InfoPhotoWrapper>
          <TextV2 typographyVariant="hed3" textAlign="center">
            {eventDisplayName}
          </TextV2>
        </AdminMenuInfo>
        <AdminMenuNav>
          <AdminMenuNavList>
            {menuOptions.map(option => (
              <AdminMenuNavListItem key={option.title}>
                {option.hasDivider ? <AdminMenuNavListDivider /> : null}
                <AdminMenuNavButton href={option.path} onClick={option.onClick}>
                  <option.icon />
                  <TextV2 typographyVariant="body1">{option.title}</TextV2>
                </AdminMenuNavButton>
              </AdminMenuNavListItem>
            ))}
          </AdminMenuNavList>
        </AdminMenuNav>
      </AdminMenuDropdown>
    </AdminMenuRoot>
  );
});
